/**
 * @file class
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { createContext } from '@tencent/glue-react-use';
var _a = createContext({}), ClassProvider = _a[0], useClassInstance = _a[1];
export { ClassProvider, useClassInstance, };
